import { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

import {
  Dialog,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";

import "./CreateSession.css";
import "../Components/Components.css";
import { createInAppCallSession } from "../Store/Actions/CallAction";

const CreateSession = ({ isOpen, setIsCreateSessionShown }) => {
  const [callType, setCallType] = useState("VIDEOCALL");
  const [description, setDescription] = useState("");
  const [expiresIn, setExpiresIn] = useState(12);
  const [generatedSessionID, setGeneratedSessionID] = useState("");
  const [isGeneratingSession, setIsGeneratingSession] = useState(false);
  const [isSessionCreated, setIsSessionCreated] = useState(false);
  const [maxRetries, setMaxRetries] = useState(15);

  const handleClose = () => {
    setCallType("VIDEOCALL");
    setDescription("");
    setExpiresIn(12);
    setIsGeneratingSession(false);
    setIsSessionCreated(false);
    setGeneratedSessionID("");
    setMaxRetries(15);
    setIsCreateSessionShown(false);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog create-session"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <div className="title">
            <h2>New In-app Call Session</h2>
          </div>

          <div className="select-data-source">
            {isSessionCreated ? (
              <section className="session-created">
                <Icon
                  color="#0343c7"
                  height="120"
                  icon="line-md:confirm-circle"
                />

                <p>Session created!</p>

                <div className="created-session">
                  <p>
                    https://demo.moxcal.com/in-app-
                    {callType === "VIDEOCALL" ? "video-" : ""}call?sessionid=
                    {generatedSessionID}
                  </p>

                  <Tooltip arrow placement="top" title="Copy Link">
                    <IconButton
                      onClick={() =>
                        navigator.clipboard.writeText(
                          `https://demo.moxcal.com/in-app-${callType === "VIDEOCALL" ? "video-" : ""}call?sessionid=${generatedSessionID}`
                        )
                      }
                    >
                      <Icon
                        height="24"
                        icon="material-symbols:content-copy-rounded"
                      />
                    </IconButton>
                  </Tooltip>
                </div>

                <button className="create" onClick={handleClose}>
                  Close
                </button>
              </section>
            ) : (
              <>
                <TextField
                  className="search-item"
                  label="Call Type"
                  select
                  value={callType}
                  onChange={(e) => setCallType(e.target.value)}
                >
                  <MenuItem value="VIDEOCALL">Video Call</MenuItem>
                  <MenuItem value="VOICECALL">Voice Call</MenuItem>
                </TextField>

                <TextField
                  className="search-item"
                  inputProps={{ readOnly: true }}
                  label="Expires In"
                  select
                  value={expiresIn}
                  onChange={(e) => setExpiresIn(e.target.value)}
                >
                  <MenuItem value={1}>1 Hour</MenuItem>
                  <MenuItem value={2}>2 Hours</MenuItem>
                  <MenuItem value={3}>3 Hours</MenuItem>
                  <MenuItem selected value={12}>12 Hours</MenuItem>
                </TextField>

                <TextField
                  className="search-item"
                  inputProps={{ readOnly: true }}
                  label="Max Retries"
                  select
                  value={maxRetries}
                  onChange={(e) => setMaxRetries(e.target.value)}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem selected value={15}>15</MenuItem>
                </TextField>

                <TextField
                  label="Description (Optional)"
                  minRows={2}
                  multiline
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />

                <button
                  className="create"
                  onClick={() => {
                    setIsGeneratingSession(true);
                    const sessionID = crypto.randomUUID();
                    setGeneratedSessionID(sessionID);

                    createInAppCallSession({
                      sessionid: sessionID,
                      calltype: callType,

                      expiretime: moment()
                        .add(expiresIn, "hours")
                        .toISOString(true),

                      description: description,
                      maxretries: maxRetries,
                    })
                      .then((response) => {
                        if (response.status) {
                          setIsGeneratingSession(false);
                          setIsSessionCreated(true);
                        } else {
                          console.log("error", response.error);
                          setIsGeneratingSession(false);

                          toast.error(
                            "Error generating session: " + response.error,

                            {
                              autoClose: 3000,
                            }
                          );
                        }
                      })
                      .catch((err) => {
                        console.log("err", err);
                        setIsGeneratingSession(false);

                        toast.error("Error generating session: " + err, {
                          autoClose: 3000,
                        });
                      });

                    console.log("payload", {
                      sessionid: sessionID,
                      calltype: callType,

                      expiretime: moment()
                        .add(expiresIn, "hours")
                        .toISOString(true),

                      description: description,
                    });
                  }}
                >
                  {isGeneratingSession
                    ? "Generating Session..."
                    : "Create Session"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateSession;
